export function formatNumber(number: any, showDecimal: boolean): string {
  if (isNaN(parseFloat(number))) {
    number = 0;
  }

  number = parseFloat(number) / 100; // 将分转换为元

  if (showDecimal) {
    return number.toFixed(2);
  } else {
    return Math.floor(number).toString();
  }
}

export function regexMobile(mobile: string) {
  return /^1[1-9]\d{9}$/.test(mobile);
}

export function regexLengthNumber(number: string, length: number) {
  return new RegExp(`^\\d{${length}}$`).test(number);
}

export function regexUrl(url: string) {
  return /^(http|https):\/\/\w/.test(url);
}

// 保留小数位
export function toFixedNumber(num, precision) {
  const factor = Math.pow(10, precision);
  return Math.floor(num * factor) / factor;
}

export const parseUserAgent = (userAgent: string) => {
  let browser = 'Unknown';
  let os = 'Unknown';

  // 检测浏览器
  if (userAgent.includes('Edg/')) {
    browser = 'Microsoft Edge';
  } else if (userAgent.includes('Chrome/')) {
    browser = 'Google Chrome';
  } else if (userAgent.includes('Safari/') && !userAgent.includes('Chrome/')) {
    browser = 'Safari';
  } else if (userAgent.includes('Firefox/')) {
    browser = 'Mozilla Firefox';
  } else if (userAgent.includes('MSIE ') || userAgent.includes('Trident/')) {
    browser = 'Internet Explorer';
  }

  // 检测操作系统
  if (userAgent.includes('Mac OS X')) {
    os = 'Mac OS X';
  } else if (userAgent.includes('Windows NT')) {
    os = 'Windows';
  } else if (userAgent.includes('Linux')) {
    os = 'Linux';
  } else if (userAgent.includes('Android')) {
    os = 'Android';
  } else if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
    os = 'iOS';
  }

  return { browser, os };
};

import dayjs from 'dayjs';

export const formatTimeDiff = (t1, t2) => {
  const sec = Math.abs(dayjs(t2).diff(dayjs(t1), 'second'));
  return sec < 60
    ? `${sec}秒`
    : sec < 3600
    ? `${Math.floor(sec / 60)}分${sec % 60}秒`
    : `${Math.floor(sec / 3600)}小时${Math.floor((sec % 3600) / 60)}分${
        sec % 60
      }秒`;
};

export function keywordHighlight(text: string, keywords: string[]) {
  const highlights = keywords;
  if (!text || !highlights || !Array.isArray(highlights)) return text;

  // Escape special characters for regex
  const escapeRegExp = (str: string) =>
    str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  // Create a regular expression to match all highlight terms
  const regex = new RegExp(`(${highlights.map(escapeRegExp).join('|')})`, 'gi');
  // console.warn(regex);

  // Replace matched terms with highlighted versions
  return text.replace(
    regex,
    '<span class="highlight" style="color: #f50;font-weight: bold;">$1</span>'
  );
}

// 格式化duration，单位秒
// 最终返回花费了N分钟N秒
export const formatDuration = (duration: number) => {
  if (isNaN(duration) || duration < 0) {
    return '0秒';
  }
  const minutes = Math.floor(duration / 60);
  const seconds = duration % 60;
  let result = '';
  if (minutes > 0) {
    result += `${minutes}分`;
  }
  if (seconds > 0) {
    result += `${seconds}秒`;
  }
  return result || '0秒';
};
